import { forwardRef, type ReactNode } from "react"

import { AnimatedElement } from "../AnimatedElement"
import { Icon } from "../Icon"
import styles from "./Draggable.module.css"

type DraggableProps = {
  children?: ReactNode
  disabled?: boolean
}

export const Draggable = forwardRef<HTMLDivElement, DraggableProps>(
  function Draggable(props, ref) {
    const { children, disabled = false } = props

    return (
      <div ref={ref} className={styles.draggable} draggable={!disabled}>
        {children}
        <AnimatedElement
          animation={{ name: "expand-horizontal" }}
          sx={{ alignSelf: "center" }}
        >
          {!disabled && (
            <div className={styles.dragIndicator}>
              <Icon name="dragIndicator" color="grey8" size="small" />
            </div>
          )}
        </AnimatedElement>
      </div>
    )
  },
)
